import adminChildren from "@/router/childrens/admin/admin-children";
import casesChildren from "@/router/childrens/atm-front/cases-childrens";
import { useUserStore } from "@/store/modules/user";

const Pilotage = () => import("@/components/atm-front/Pilotage.vue");

const Cases = () => import("@/components/atm-front/Cases.vue");

const Admin = () => import("@/components/atm-front/Admin.vue");

const MyProfile = () => import("@/components/atm-front/MyProfile.vue");

const privilegedAccess = async (to, from, next) => {
  const userStore = useUserStore();
  const user = userStore.currentUser;
  if (user.isPrivileged()) {
    next();
  } else {
    next({ name: "casesList" });
  }
};

export default [
  {
    path: "",
    name: "home",
    redirect: { name: "casesList" },
  },
  {
    path: "cases",
    component: Cases,
    children: casesChildren,
  },
  {
    path: "pilot",
    name: "pilotage",
    component: Pilotage,
  },
  {
    path: "profile",
    name: "edit-profile", // INFO - MS - route name comes from SocioMainNavbarUserMenu (socio-vue-components)
    component: MyProfile,
  },
  {
    path: "admin",
    component: Admin,
    children: adminChildren,
    beforeEnter: privilegedAccess,
  },
];
